var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.3652C17 16.5744 15.2091 18.3652 13 18.3652C10.7909 18.3652 9 16.5744 9 14.3652C9 12.1561 10.7909 10.3652 13 10.3652C15.2091 10.3652 17 12.1561 17 14.3652ZM5 14.3652C5 18.7835 8.58172 22.3652 13 22.3652C17.4183 22.3652 21 18.7835 21 14.3652C21 9.94695 17.4183 6.36523 13 6.36523C8.58172 6.36523 5 9.94695 5 14.3652ZM18 33.3652C18 30.6038 15.7614 28.3652 13 28.3652C10.2386 28.3652 8 30.6038 8 33.3652V38.3652H18V33.3652ZM22 42.3652H4V33.3652C4 28.3946 8.02944 24.3652 13 24.3652C17.9706 24.3652 22 28.3946 22 33.3652V42.3652ZM39 14.3652C39 16.5744 37.2092 18.3652 35 18.3652C32.7908 18.3652 31 16.5744 31 14.3652C31 12.1561 32.7908 10.3652 35 10.3652C37.2092 10.3652 39 12.1561 39 14.3652ZM27 14.3652C27 18.7835 30.5818 22.3652 35 22.3652C39.4182 22.3652 43 18.7835 43 14.3652C43 9.94695 39.4182 6.36523 35 6.36523C30.5818 6.36523 27 9.94695 27 14.3652ZM40 33.3652C40 30.6038 37.7614 28.3652 35 28.3652C32.2386 28.3652 30 30.6038 30 33.3652V38.3652H40V33.3652ZM26 38.3652V33.3652C26 28.3946 30.0294 24.3652 35 24.3652C39.9706 24.3652 44 28.3946 44 33.3652V42.3652H26V38.3652Z",
    fill: "#3940A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentor);
export default __webpack_public_path__ + "static/media/Mentor.917af8e324a47793792ff4fd1f977708.svg";
export { ForwardRef as ReactComponent };